import { render, staticRenderFns } from "./product_distributor_information.vue?vue&type=template&id=6b547dfc&scoped=true&"
import script from "./product_distributor_information.vue?vue&type=script&lang=js&"
export * from "./product_distributor_information.vue?vue&type=script&lang=js&"
import style0 from "./product_distributor_information.vue?vue&type=style&index=0&id=6b547dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b547dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b547dfc')) {
      api.createRecord('6b547dfc', component.options)
    } else {
      api.reload('6b547dfc', component.options)
    }
    module.hot.accept("./product_distributor_information.vue?vue&type=template&id=6b547dfc&scoped=true&", function () {
      api.rerender('6b547dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/extra_components/product_distributor_information.vue"
export default component.exports